import React from 'react';

/**
 * Conditionally renders its children based on the `visible` prop.
 * If `visible` is false, renders the `fallback` node (or nothing if not provided).
 *
 * @param {Object} props
 * @param {boolean} props.visible - Whether to render children.
 * @param {React.ReactNode} props.children - The content to render when visible is true.
 * @param {React.ReactNode} [props.fallback=null] - The content to render when visible is false.
 * @returns {React.ReactNode} Rendered children or fallback.
 *
 * @example
 * <Visibility visible={userCanSee}>
 *   <button>Edit</button>
 * </Visibility>
 *
 * <Visibility visible={isLoaded} fallback={<Spinner />}>
 *   <DataComponent />
 * </Visibility>
 */
export const Visibility = ({ visible, children, fallback = null }) => {
    if (!visible) {
        return fallback;
    }

    return <>{children}</>;
};
